import React from 'react';
import PropTypes from 'prop-types';

import EditButton from 'components/ResourceNotes/Views/Edit/Index';
import DeleteButton from 'components/ResourceNotes/Views/Delete/Index';

export default function Actions({ row }) {
  return (
    <>
      <EditButton note={row} />
      <DeleteButton note={row} />
    </>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
